import { Flex, Box } from '@cad-arc';
import { EventSearchOptions } from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { FormSelect } from '../forms/integrated-form-controls/form-select';
import { FormSection } from '../search-windows/form-section';
import { EventSearchFormType } from './types';
import { INPUT_WIDTH_SM, INPUT_WIDTH_MD } from '../search-windows/constants';
import { useApplicationType } from '../common/hooks/use-application-type';

export function EventSearchFormDispositionsSection({
    form,
    options,
}: {
    form: UseFormReturn<EventSearchFormType>;
    options: EventSearchOptions;
}) {
    const { isFirstResponder } = useApplicationType();

    return (
        <FormSection title="Dispositions">
            <Flex flex={1} flexFlow="wrap" gap="1rem">
                <Box w={isFirstResponder ? INPUT_WIDTH_MD : INPUT_WIDTH_SM}>
                    <FormSelect
                        name="primaryDispositions"
                        label="Primary Dispositions"
                        control={form.control}
                        options={options.dispositionOptions}
                        isMultiple
                        truncateSelectedCount={2}
                    />
                </Box>
                <Box w={isFirstResponder ? INPUT_WIDTH_MD : INPUT_WIDTH_SM}>
                    <FormSelect
                        name="secondaryDispositions"
                        label="Secondary Dispositions"
                        control={form.control}
                        options={options.dispositionOptions}
                        isMultiple
                        truncateSelectedCount={2}
                    />
                </Box>
            </Flex>
        </FormSection>
    );
}
